var map = {
	"./images/backgrounds/404_generic.png": 429,
	"./images/backgrounds/carousel/qello/1.png": 848,
	"./images/backgrounds/carousel/qello/2.png": 849,
	"./images/backgrounds/carousel/qello/3.png": 850,
	"./images/backgrounds/carousel/qello/4.png": 851,
	"./images/backgrounds/carousel/qello/5.png": 852,
	"./images/backgrounds/carousel/qello/6.png": 853,
	"./images/backgrounds/carousel/qello/7.png": 854,
	"./images/backgrounds/en/stingray_business.png": 855,
	"./images/backgrounds/en/stingray_classica.jpg": 856,
	"./images/backgrounds/en/stingray_classica_mobile.jpg": 857,
	"./images/backgrounds/en/stingray_classica_tablet.jpg": 858,
	"./images/backgrounds/en/stingray_karaoke.png": 859,
	"./images/backgrounds/en/stingray_music.jpg": 860,
	"./images/backgrounds/en/stingray_qello.jpg": 861,
	"./images/backgrounds/es/stingray_business.png": 862,
	"./images/backgrounds/fr/stingray_business.png": 863,
	"./images/backgrounds/fr/stingray_music.png": 864,
	"./images/backgrounds/popups/classica.png": 865,
	"./images/backgrounds/popups/music.png": 866,
	"./images/backgrounds/popups/qello.png": 867,
	"./images/common/back-arrow.svg": 420,
	"./images/common/back.svg": 817,
	"./images/common/close.svg": 818,
	"./images/common/communication.png": 2050,
	"./images/common/dropdown_arrow.svg": 819,
	"./images/common/dropdown_arrow_light_gray.svg": 421,
	"./images/common/icon_stingray.svg": 820,
	"./images/common/reload.svg": 821,
	"./images/icon/amazon.svg": 822,
	"./images/icon/apple.svg": 823,
	"./images/icon/email.svg": 824,
	"./images/icon/email_gray.svg": 825,
	"./images/icon/facebook.svg": 826,
	"./images/icon/google.svg": 827,
	"./images/icon/hide_password.svg": 828,
	"./images/icon/maintenance_icon.svg": 829,
	"./images/icon/mobile.svg": 203,
	"./images/icon/phone.svg": 2042,
	"./images/icon/show_password.svg": 830,
	"./images/icon/tv.svg": 2043,
	"./images/logo/de/apple_store.svg": 831,
	"./images/logo/de/google_store.png": 868,
	"./images/logo/en/apple_store.svg": 832,
	"./images/logo/en/google_store.png": 869,
	"./images/logo/en/logo-smc-white.svg": 833,
	"./images/logo/en/stingray_business_logo_horizontal.svg": 834,
	"./images/logo/en/stingray_classica_horizontal.svg": 835,
	"./images/logo/en/stingray_karaoke_logo.png": 870,
	"./images/logo/en/stingray_logo_horizontal.svg": 836,
	"./images/logo/en/stingray_music_hor_white.svg": 837,
	"./images/logo/en/stingray_qello_horizontal.svg": 838,
	"./images/logo/en/tsm_karaoke_horizontal.png": 871,
	"./images/logo/es/apple_store.svg": 839,
	"./images/logo/es/google_store.png": 872,
	"./images/logo/fi/apple_store.svg": 840,
	"./images/logo/fi/google_store.png": 873,
	"./images/logo/fr/apple_store.svg": 841,
	"./images/logo/fr/google_store.png": 874,
	"./images/logo/fr/stingray_business_logo_horizontal.svg": 842,
	"./images/logo/fr/stingray_music_hor_white.svg": 843,
	"./images/logo/hu/apple_store.svg": 844,
	"./images/logo/hu/google_store.png": 875,
	"./images/logo/logo_classica.svg": 422,
	"./images/logo/logo_music.svg": 423,
	"./images/logo/logo_qello.svg": 424,
	"./images/logo/logo_smc.svg": 425,
	"./images/logo/logo_stingray.svg": 426,
	"./images/logo/logo_stingraykaraoke.svg": 427,
	"./images/logo/nb/apple_store.svg": 845,
	"./images/logo/nb/google_store.png": 876,
	"./images/logo/nl/apple_store.svg": 846,
	"./images/logo/nl/google_store.png": 877,
	"./images/logo/pt/apple_store.svg": 847,
	"./images/logo/pt/google_store.png": 878,
	"./images/logo/stingray.svg": 428,
	"./images/logo/stingray_logo_horizontal_white.svg": 99,
	"./images/qrSteps/login_gear.png": 879,
	"./images/qrSteps/login_step_1.png": 880,
	"./images/qrSteps/login_step_2.png": 881,
	"./images/subscription/classica.png": 882,
	"./images/subscription/classica.svg": 2044,
	"./images/subscription/classica_dark.png": 883,
	"./images/subscription/karaoke.png": 884,
	"./images/subscription/karaoke.svg": 2045,
	"./images/subscription/karaoke_dark.png": 885,
	"./images/subscription/music.png": 886,
	"./images/subscription/music.svg": 2046,
	"./images/subscription/musicVideo.svg": 2047,
	"./images/subscription/music_dark.png": 887,
	"./images/subscription/qello.png": 888,
	"./images/subscription/qello.svg": 2048,
	"./images/subscription/qello_dark.png": 889,
	"./images/subscription/tsm.png": 890,
	"./images/subscription/tsm.svg": 2049,
	"./images/subscription/tsm_dark.png": 891,
	"./images/svgExcludeInline/close.svg": 419,
	"./images/welcome/expertly_curated.png": 892,
	"./images/welcome/karaoke_tsm_pineapple.png": 430,
	"./images/welcome/on_the_go.png": 893,
	"./images/welcome/unlimited_skips.png": 894
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2051;



//////////////////
// WEBPACK FOOTER
// ./res ^\.\/images.*$
// module id = 2051
// module chunks = 0